import { styled } from '@linaria/react';

import { ButtonBase } from '~shared/ui/atoms';

export const StyledBase = styled(ButtonBase)`
	--bg: var(--color-white-01);
	--color: var(--color-white);
	backdrop-filter: blur(12.5px);

	@media (pointer: fine) {
		&:hover {
			--bg: var(--color-white-02);
		}
	}

	@media (pointer: coarse) {
		&:active {
			--bg: var(--color-white-02);
		}
	}

	&[disabled] {
		--color: var(--color-white-01);
	}
`;
